import React, { useContext } from 'react'
import SignupContext from 'modules/react/signup/SignupContext'

export default function WhenStep ({ is, children }) {

  const { step } = useContext(SignupContext)

  if (step !== is) {
    return null
  }

  return children
}